export default __webpack_public_path__ + "static/media/welcome-streamlined-pm.e3aed0c0.png";